import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/switchMap';
import { concat } from 'rxjs/observable/concat';
import { type ActionsObservable } from 'redux-observable';
import {
	CHECK_ACTIVATION_STATUS_ERROR,
	type checkConfluenceActivationStatusFailed,
	markActivationFailed,
} from '../actions/activate-confluence';
import { showActivationErrorFlag } from '../actions';

export default (
	action$: ActionsObservable<ReturnType<typeof checkConfluenceActivationStatusFailed>>,
) =>
	action$.ofType(CHECK_ACTIVATION_STATUS_ERROR).switchMap(() => {
		return concat([markActivationFailed(), showActivationErrorFlag()]);
	});
